module.exports = __webpack_public_path__ + "img/197.3499048d.jpg";